import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import SignIn from '@/components/auth/SignIn.vue'
export default /*#__PURE__*/_defineComponent({
  __name: 'SignInView',
  setup(__props) {


return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createBlock(SignIn, null, {
    footer: _withCtx(() => [
      _createTextVNode(" Or "),
      _createVNode(_component_router_link, { to: {name: 'signup'} }, {
        default: _withCtx(() => [
          _createTextVNode("sign up")
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})